export default __webpack_public_path__ + "static/brown-dog-sitting-7c73fa7eb1eec39a38603af03d67d705.jpg";